const urlSafeBase64 = string => {
  return Buffer.from(string)
    .toString('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
};

module.exports = urlSafeBase64;
